// extracted by mini-css-extract-plugin
export default {"vendor":"Vendor_vendor__3XL08"};